import { Button, Stack } from "@mui/material";
import { type FC, useMemo } from "react";
import { ChatMessageGroup } from "web_myplann/Chat/Components/Messages/ChatMessageGroup";
import { groupChatMessages } from "web_myplann/Chat/Helpers/Messages/groupChatMessages";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	messages: ChatMessageView[];
	advisorName: string;
	advisorPhoto?: string;
	hasOlder: boolean;
	isLoadingOlder: boolean;
	onLoadOlder: () => void;
	onRetry: (message: ChatMessageView) => void;
};

export const ChatMessageList: FC<Props> = ({
	messages,
	advisorName,
	advisorPhoto,
	hasOlder,
	isLoadingOlder,
	onLoadOlder,
	onRetry,
}) => {
	const { t } = useResource();
	const groups = useMemo(() => groupChatMessages(messages), [messages]);

	return (
		<>
			{hasOlder && (
				<Stack direction="row" justifyContent="center" mb={1.6}>
					<Button
						variant="textLink"
						onClick={onLoadOlder}
						disabled={isLoadingOlder}
					>
						{t(Resources.Chat.loadOlder)}
					</Button>
				</Stack>
			)}

			{groups.map((group) => (
				<ChatMessageGroup
					key={group.key}
					group={group}
					advisorName={advisorName}
					advisorPhoto={advisorPhoto}
					onRetry={onRetry}
				/>
			))}
		</>
	);
};
